import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    let cbx = document.querySelectorAll('noss-emergency select');
    if (cbx) {
        for (let i = 0; i < cbx.length; ++i) {
            cbx[i].addEventListener('change', function (event) {
                let frm = event.target.closest('form');
                if (frm) {
                    htmx.trigger(frm, 'submit');
                }
            });
        }
    }
}
